<template>
  <Nav />
  <div class="container">
    <div class="upload-container">
      <div class="row mb-3">
        <div class="col-md-12">
          <h1 class="h3 mb-3 poppins-light">
            Envie seu arquivo para o FALCON
            <span class="poppins-semibold">RANK</span>
          </h1>
          <!-- <h4>Enviando arquivo para: {{ razao_social }}</h4> -->
        </div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <div class="form-group">
            <label for="entidade" class="label-upload"
              >Enviando arquivo para:</label
            >
            <input
              type="text"
              class="form-control text-muted"
              id="entidade"
              :value="razao_social"
              readonly
            />
          </div>
        </div>
        <div class="col-md-3">
          <div
            :class="[
              'form-group',
              { 'has-error': !exercicio && showValidationErrors },
            ]"
          >
            <label for="exercicio" class="label-upload">Exercício:</label>
            <select
              class="form-control"
              name="exercicio"
              id="exercicio"
              v-model="exercicio"
            >
              <option value="" disabled>Selecionar</option>
              <option v-for="exercicio in entidadeExercicios" :key="exercicio">
                {{ exercicio }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <div
            :class="[
              'form-group',
              { 'has-error': !tipoArquivoSelecionado && showValidationErrors },
            ]"
          >
            <label for="tipoArquivo" class="label-upload">Tipo de arquivo:</label>
            <select
              class="form-control"
              name="tipoArquivo"
              id="tipoArquivo"
              v-model="tipoArquivoSelecionado"
            >
              <option value="" disabled>Selecionar</option>
              <option v-for="tipoArquivo in tipoArquivos" :key="tipoArquivo">
                {{ tipoArquivo }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div
            :class="[
              'form-group',
              { 'has-error': !periodoSelecionado && showValidationErrors },
            ]"
          >
            <label for="periodo" class="label-upload">Referente a:</label>
            <select
              class="form-control"
              name="periodo"
              id="periodo"
              v-model="periodoSelecionado"
            >
              <option value="" disabled>Selecionar</option>
              <option v-for="(value, key) in periodos" :key="key" :value="key">
                {{ key }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <input
            type="file"
            class="form-control"
            name="file"
            id="fileInput"
            ref="fileInput"
            @change="handleFileChange"
            style="display: none"
          />
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              id="fileName"
              :value="fileName"
              disabled
            />
            <button
              class="btn btn-escolher-arq poppins-light"
              @click="openFileDialog"
            >
              Escolher Arquivo
            </button>
          </div>
        </div>
        <div class="col-md-3">
          <button
            class="btn btn-success btn-enviar poppins-light"
            id="sendFile"
            :disabled="!fileName || !exercicio || !tipoArquivoSelecionado || !periodoSelecionado || isUploading"
            @click="openConfirmationModal"
            ref="sendButton"
          >
            Enviar arquivo
            <span
              v-if="isUploading"
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
        </div>
      </div>
      <div v-if="uploadSuccess" class="row mt-3">
        <div class="col-md-12">
          <div
            class="alert alert-success alert-dismissible fade show"
            role="alert"
          >
            <p>{{ uploadSuccessMessage }}</p>
            <p>Protocolo: <strong>{{ uploadSuccessProtocol }}</strong></p>
            <button
              type="button"
              class="btn-close"
              @click="uploadSuccess = false"
              aria-label="Close"
            ></button>
          </div>
        </div>
      </div>
      <div v-if="uploadError" class="row mt-3">
        <div class="col-md-12">
          <div
            class="alert alert-danger alert-dismissible fade show"
            role="alert"
          >
            {{ uploadError }}
            <button
              type="button"
              class="btn-close"
              @click="uploadError = ''"
              aria-label="Close"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="confirmationModal"
    tabindex="-1"
    aria-labelledby="confirmationModalLabel"
    :inert="!isModalVisible"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="confirmationModalLabel">
            Confirmar Envio
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <p><strong>Entidade:</strong> {{ razao_social }}</p>
          <p><strong>Exercício:</strong> {{ exercicio }}</p>
          <p><strong>Tipo de arquivo:</strong> {{ tipoArquivoSelecionado }}</p>
          <p><strong>Referente a:</strong> {{ periodoSelecionado }}</p>
          <p><strong>Arquivo:</strong> {{ fileName }}</p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary"
            data-bs-dismiss="modal"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            @click="confirmSendFile"
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosApi from "@/axios";
import JSZip from "jszip";
// Modal and Tooltip are available via window.bootstrap from CDN // Import Bootstrap's JavaScript module
import Nav from "@/components/Nav.vue";
import { mapActions, mapState } from "vuex";

export default {
  name: "Upload",
  data() {
    return {
      isDragOver: false,
      fileName: "",
      exercicio: "", // Predefined value
      entidade: {}, // Predefined value
      tipoArquivoSelecionado: "", // Predefined value
      periodoSelecionado: "", // Predefined value
      mes: "", // Predefined value
      razao_social: "", // Predefined value
      uploadSuccess: false,
      uploadError: "",
      isUploading: false,
      isModalVisible: false,
      showValidationErrors: false,
      entidadeExercicios: [],
      tipoArquivos: ["MSC - Matriz de Saldos Contábeis", "RREO - Relatório Resumido da Execução Orçamentária", "RGF - Relatório de Gestão Fiscal", "DCA - Demonstrativo de Contas Anuais"],
      periodos: [], // Initialize as an empty array
      lrf_rgf_simplificado: false,
      uploadSuccessMessage: "",
      uploadSuccessProtocol: "",
      pendencia_financeira: false
    };
  },
  computed: {
    ...mapState(["cidade", "userEntidade", "codigoSiconfi", "isDemo", "hasPendencia"]),
  },
  async created() {
    try {
      await this.validateToken();
      this.checkUserEntidade();
      await this.initializeEntidadeData();
      this.checkPendenciaEntidade();
    } catch (error) {
      console.log(error);
      this.handleUnauthenticated();
    }
  },
  watch: {
    tipoArquivoSelecionado(newTipoArquivo) {
      if (newTipoArquivo === "MSC - Matriz de Saldos Contábeis") {
        this.periodos = {
          "01 - Janeiro": "MSC/01",
          "02 - Fevereiro": "MSC/02",
          "03 - Março": "MSC/03",
          "04 - Abril": "MSC/04",
          "05 - Maio": "MSC/05",
          "06 - Junho": "MSC/06",
          "07 - Julho": "MSC/07",
          "08 - Agosto": "MSC/08",
          "09 - Setembro": "MSC/09",
          "10 - Outubro": "MSC/10",
          "11 - Novembro": "MSC/11",
          "12 - Dezembro": "MSC/12",
          "13 - Encerramento": "MSC/13",
        }
      } else if (newTipoArquivo === "RREO - Relatório Resumido da Execução Orçamentária") {
        this.periodos = {
          "1º Bimestre": "RREO/01",
          "2º Bimestre": "RREO/02",
          "3º Bimestre": "RREO/03",
          "4º Bimestre": "RREO/04",
          "5º Bimestre": "RREO/05",
          "6º Bimestre": "RREO/06"
        }
      } else if (newTipoArquivo === "RGF - Relatório de Gestão Fiscal") {
        if (this.lrf_rgf_simplificado === true) {
          this.periodos = {
            "1º Semestre (Executivo)": "RGF/Executivo/01",
            "2º Semestre (Executivo)": "RGF/Executivo/02",
            "1º Semestre (Legislativo)": "RGF/Legislativo/01",
            "2º Semestre (Legislativo)": "RGF/Legislativo/02"
          }
        } else {
          this.periodos = {
            "1º Quadrimestre (Executivo)": "RGF/Executivo/01",
            "2º Quadrimestre (Executivo)": "RGF/Executivo/02",
            "3º Quadrimestre (Executivo)": "RGF/Executivo/03",
            "1º Quadrimestre (Legislativo)": "RGF/Legislativo/01",
            "2º Quadrimestre (Legislativo)": "RGF/Legislativo/02",
            "3º Quadrimestre (Legislativo)": "RGF/Legislativo/03"
          }
        }
      } else if (newTipoArquivo === "DCA - Demonstrativo de Contas Anuais") {
        this.periodos = ["Anual"];
        this.periodos = {
          "Anual": "DCA/Anual"
        }
      } else {
        this.periodos = [];
      }
      this.periodo = ""; // Reset the selected periodo
    },
    exercicio(newExercicio) {
      this.tipoArquivoSelecionado = "";
      this.periodoSelecionado = "";
      this.lrf_rgf_simplificado = newExercicio ? this.entidade.exercicios[newExercicio].lrf_rgf_simplificado : false;
    }
  },
  methods: {
    ...mapActions(["validateToken"]),
    checkMunicipioDemo() {
      return this.isDemo;
    },
    async initializeEntidadeData() {
      const entidadeResponse = await axiosApi.get(
        `/api/entidades/${this.codigoSiconfi}`,
        { withCredentials: true }
      );
      this.entidade = entidadeResponse.data.data;
      this.razao_social = this.entidade.razao_social;
      this.pendencia_financeira = this.entidade.pendencia_financeira;
      this.entidadeExercicios = Object.keys(this.entidade.exercicios);
    },
    openFileDialog() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        const validExtensions = ["xml", "csv"];
        const fileExtension = file.name.split(".").pop().toLowerCase();
        if (!validExtensions.includes(fileExtension)) {
          this.uploadError =
            "Formato de arquivo inválido. Apenas arquivos XML ou CSV são permitidos.";
          this.fileName = "";
          this.$refs.fileInput.value = null; // Clear the file input
          return;
        }
        this.fileName = file.name;
        this.uploadError = ""; // Clear any previous error
      }
    },
    openConfirmationModal() {

      const tooltip = new window.bootstrap.Tooltip(this.$refs.sendButton, {
        title: "Preencha todos os campos",
        placement: "top",
        trigger: "manual",
      });
      tooltip.show();
      setTimeout(() => {
        tooltip.hide();
      }, 3000);


      if (!this.razao_social || !this.exercicio || !this.tipoArquivoSelecionado || !this.periodoSelecionado || !this.fileName) {
        this.showValidationErrors = true;
        const tooltip = new window.bootstrap.Tooltip(this.$refs.sendButton, {
          title: "Preencha todos os campos",
          placement: "top",
          trigger: "manual",
        });
        tooltip.show();
        setTimeout(() => {
          tooltip.hide();
        }, 3000);
        return;
      }
      this.showValidationErrors = false;
      this.isModalVisible = true;
      const modal = new window.bootstrap.Modal(document.getElementById("confirmationModal"));
      modal.show();
    },
    async confirmSendFile() {
      this.isModalVisible = false;
      const modal = window.bootstrap.Modal.getInstance(
        document.getElementById("confirmationModal")
      );
      modal.hide();
      if (this.checkMunicipioDemo()) {
        this.uploadError = "Este município é uma demonstração e não está habilitado para enviar arquivos.";
        return;
      }
      await this.sendFile();
    },
    async sendFile() {
      console.log("Sending file...");
      this.uploadSuccess = false;
      this.uploadSuccessMessage = "";
      this.uploadSuccessProtocol = "";
      this.uploadError = "";
      this.isUploading = true;
      try {
        const file = this.$refs.fileInput.files[0];
        const formData = new FormData();
        var fileExtension = file.name.split(".").pop().toLowerCase();

        if (fileExtension === "xml") {
          console.log("Zipping file...");
          const zip = new JSZip();
          zip.file(file.name, file);
          const zippedFile = await zip.generateAsync({
            type: "blob",
            compression: "DEFLATE",
          });
          console.log("Zipped file size:", zippedFile.size / 1e6, "Mb");
          formData.append("file", zippedFile, `${file.name}.zip`);
          formData.append("extension", 'zip');
        } else {
          formData.append("file", file);
          formData.append("extension", fileExtension);
        }
        
        const chaveArquivo = `${this.exercicio}/${this.periodos[this.periodoSelecionado]}`;

        formData.append("chave", chaveArquivo);
        formData.append("exercicio", this.exercicio);
        formData.append("codigo_siconfi", this.codigoSiconfi);
        formData.append("lrf_rgf_simplificado", this.lrf_rgf_simplificado);

        console.log("Requesting...");

        const response = await axiosApi.post("/api/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
          timeout: 30000, //30seconds,
          timeoutErrorMessage: "O envio do arquivo excedeu o limite de 30 segundos!"
        });

        console.log("Responsing...");

        if (response.data.success) {
          this.uploadSuccessMessage = response.data.message;
          this.uploadSuccessProtocol = response.data.protocol;
          this.uploadSuccess = true;
          this.uploadError = "";
        }
      } catch (error) {
        console.log(error.response);
        if (error.response && error.response.data.code === "UNAUTHENTICATED") {
          this.handleUnauthenticated();
        } else {
          this.uploadError = error.response
            ? error.response.data.message
            : error.message;
          this.uploadSuccess = false;
          console.error("Error sending file:", this.uploadError);
        }
      } finally {
        this.isUploading = false;
        this.exercicio = "";
        this.tipoArquivoSelecionado = "";
        this.periodoSelecionado = "";
        this.fileName = "";
        this.$refs.fileInput.value = null; // Clear the file input
      }
    },
    checkUserEntidade() {
      if (!this.$store.state.userEntidade) {
        this.$router.push("/selecaoEntidades");
      }
    },
    checkPendenciaEntidade() {
      if (this.pendencia_financeira) {
        this.$router.push("/");
      }
    },
    handleUnauthenticated() {
      this.$router.push("/login");
    },
  },
  components: {
    Nav,
  },
};
</script>

<style>
.container {
  /* margin: 20px auto; */
  display: flex;
  justify-content: center;
  width: 100%;
  /* max-width: 800px; Adjust the max-width as needed */
}

.upload-container {
  padding: 20px;
  border: 1px solid #e9ecef;
  border-radius: 5px;
  width: 100%;
  min-width: 800px; /* Adjust the max-width as needed */
}

.btn {
  width: auto;
}

.btn-enviar {
  width: 100%;
  background-color: var(--azul-escuro) !important;
  border-color: var(--azul-escuro) !important;
}

.btn-enviar:focus,
.btn-enviar:hover,
.btn-enviar:disabled {
  background-color: var(--azul-escuro) !important;
  border-color: var(--azul-escuro) !important;
}

.btn-enviar:focus-visible {
  box-shadow: 0 0 0 0.25rem rgba(38, 143, 255, 0.5);
}

.btn-escolher-arq,
.btn-escolher-arq:focus,
.btn-escolher-arq:hover,
.btn-escolher-arq:disabled {
  background-color: var(--azul-escuro) !important;
  border-color: var(--azul-escuro) !important;
  color: white !important;
}

.btn-escolher-arq:active,
.btn-enviar:active {
  background-color: var(--azul-final) !important;
}

.btn-escolher-arq:focus-visible {
  box-shadow: 0 0 0 0.25rem rgba(38, 143, 255, 0.5);
}

.form-group .label-upload {
  position: absolute;
  margin-top: -12px;
  background-color: white;
  color: #009dff;
  margin-left: 10px;
  padding: 0px 8px;
  font-size: 0.9rem;
}

.form-group select {
  min-height: 50px;
  margin-bottom: 15px;
}

.has-error select {
  border-color: red;
}

.text-muted {
  color: #757575 !important;
  cursor: default;
  pointer-events: none; /* Prevents clicking */
}



/* .text-muted  input:disabled{
  color: white !important;
} */
</style>
